import { AddressEntityType } from 'types/ApiResponse'

export const mapAddress = (context: [], key: any) => {
  let response
  context.forEach((ctx: any) => {
    if (ctx.id.startsWith('country') && key === 'text') {
      response = ctx.text
    }
    if (ctx.id.startsWith('country') && key === 'short_code') {
      response = ctx.short_code.toUpperCase()
    }
  })
  return response
}

export const mapAddressData = (addressData: AddressEntityType) => {
  const formatNumber = (number: number) => {
    return `${number}`.replace('.', ',')
  }
  const propertiesToFormat = [
    'livingArea',
    'plotArea',
    'commercialArea',
    'coownershipNumerator',
    'coownershipDenominator',
    'groundLeaseActualRent',
    'primaryEnergyDemand',
    'finalEnergyDemand',
    'co2Emission',
    'modernizationCost',
    'actualRent',
    'actualCommercialRent',
  ]
  const formatRecursively = (obj: any): any => {
    if (obj === null || typeof obj !== 'object') return obj

    return Object.fromEntries(
      Object.entries(obj).map(([key, value]) => {
        if (value !== null && typeof value === 'number' && propertiesToFormat.includes(key)) {
          return [key, formatNumber(value)]
        } else if (typeof value === 'object') {
          return [key, formatRecursively(value)]
        } else {
          return [key, value]
        }
      })
    )
  }

  return formatRecursively(addressData)
}
